// extracted by mini-css-extract-plugin
module.exports = {"Loading":"loading_Loading__d4qjY","center":"loading_center__yi_Su"};